import {
  CANCEL_USER_INVITATION,
  CREATE_INVITE_LINK,
  DENY_USER_REQUEST,
  GET_COMPANY,
  GET_COMPANY_NOTIFICATIONS,
  GET_USERS_INVITED_STATUS,
  GET_WORKSPACE_MACRO_INDUSTRY,
  GET_ZAI_HERO_BRAND,
  INVITE_USER,
  LIST_COMPANY_WORKSPACE_REQUESTS,
  REGISTER_USER_BY_REQUEST,
} from './operations'
import { GET_MY_BRAND_SOA } from './queries/getMyBrandSoa'
import { GET_WORKSPACE_COMPANY_PLAN } from './queries/getWorkspaceCompanyPlan'
import { GET_WORKSPACE_SENTIMENT } from './queries/getWorkspaceSentiment'
import { GET_WORKSPACE_SENTIMENT_V2 } from './queries/getWorkspaceSentimentV2'
import { GET_WORKSPACE_TOKEN } from './queries/getWorkspaceToken'
import type { TWorkspaceMutationsMap, TWorkspaceQueriesMap } from './types'

export const GRAPHQL_WORKSPACE: TWorkspaceQueriesMap = {
  getWorkspaceCompanyPlan: GET_WORKSPACE_COMPANY_PLAN,
  getWorkspaceToken: GET_WORKSPACE_TOKEN,
  getWorkspaceSentiment: GET_WORKSPACE_SENTIMENT,
  getWorkspaceSentimentV2: GET_WORKSPACE_SENTIMENT_V2,
  getWorkspaceMacroIndustry: GET_WORKSPACE_MACRO_INDUSTRY,
  getMyBrandSoa: GET_MY_BRAND_SOA,
  getZaiHeroBrand: GET_ZAI_HERO_BRAND,
  getCompanyNotifications: GET_COMPANY_NOTIFICATIONS,
  getUsersInvitedStatus: GET_USERS_INVITED_STATUS,
  getCompany: GET_COMPANY,
  listCompanyWorkspaceRequests: LIST_COMPANY_WORKSPACE_REQUESTS,
}

export const GRAPHQL_WORKSPACE_MUTATIONS: TWorkspaceMutationsMap = {
  inviteUser: INVITE_USER,
  createInviteLink: CREATE_INVITE_LINK,
  cancelUserInvitation: CANCEL_USER_INVITATION,
  registerUserByRequest: REGISTER_USER_BY_REQUEST,
  denyUserRequest: DENY_USER_REQUEST,
}
